export default __webpack_public_path__ + "static/media/spotlight-blk.66dc8ddb.svg";